<template>
  <div class="mdl-grid">
    <div class="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"></div>
    <div v-if="showNewsfeed" class="mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet">
      <welcome-message></welcome-message>
      <list-filter @update="updateNewsfeed($event)" @progress="showProgress = $event"></list-filter>
      <progress-bar v-show="showProgress"></progress-bar>

      <template v-if="newsfeed.length === 0">
        <empty-newsfeed @refresh="getNewsfeed()"></empty-newsfeed>
      </template>

      <template v-else>
        <list v-show="!showProgress"
          v-for="data in newsfeed"
          :data="data"
          :key="data.fecha"
          @showReport="showReport($event)"></list>
      </template>
    </div>
    <div v-else class="mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet">
      <audit-report :audit="clickedAudit"
        @showProgress="showProgress2 = $event"
        @showNewsfeed="showNewsfeed = $event"></audit-report>
      <progress-bar v-show="showProgress2"></progress-bar>
    </div>
    <!-- <div class="mdl-cell mdl-cell--3-col mdl-typography--text-center">
      <fab></fab>
    </div> -->
  </div>
</template>

<script>
import Welcome from './Welcome'
import List from './List'
import Filter from './Filter'
import Empty from './Empty'
import Report from './Report'
import Progress from '@/components/Shared/Progress/'

export default {
  components: {
    'welcome-message': Welcome,
    'list': List,
    'list-filter': Filter,
    'empty-newsfeed': Empty,
    'audit-report': Report,
    'progress-bar': Progress
  },
  data () {
    return {
      title: 'Newsfeed',
      newsfeed: [],
      showProgress: true,
      showProgress2: false,
      showNewsfeed: true,
      clickedAudit: {}
    }
  },
  watch: {
    showNewsfeed () {
      this.getNewsfeed()
      this.$title.show(this.title)
    }
  },
  methods: {
    getNewsfeed () {
      this.showProgress = true
      this.$http.get('auditorias/newsfeed/10')
      .then(response => {
        this.newsfeed = response.data
        return this.showProgress = false
      }).catch(error => {
        this.showProgress = false
      })
    },
    updateNewsfeed (newsfeed) {
      this.newsfeed = newsfeed
      this.showProgress = false
    },
    showReport ($event) {
      this.clickedAudit = $event
      this.showNewsfeed = false
    }
  },
  mounted () {
    this.$http.defaults.headers.common['Authorization'] = this.$user.data.email
    this.getNewsfeed()
    this.$endpoint.refresh(this.getNewsfeed)
    this.$title.show(this.title)
    this.$actionbar.destroy()
    componentHandler.upgradeDom()
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// index.vue?7aa14aa5